class SubscriptionWidget extends HTMLElement{
    constructor(){
        super()
        this.oneTimeBtn = this.querySelector('.subscription-widget__button--simple');
        this.subscriptionBtn = this.querySelector('.subscription-widget__button--subscription');
        this.subContent = this.querySelector(".subscription-widget__content");
        this.variantSelects = document.querySelectorAll('.main-product__block-variant_picker .variant-picker__option');
        this.atcSelector = document.querySelector('.sticky-atc-wrapper .sticky-atc-variant-select');
        this.productId= this.dataset.productId;
        
        this.addWidgetEventListener();
        this.addVariantEventListener();
        this.addStickyAtcEventListener();

        if(this.subscriptionBtn && this.subscriptionBtn.classList.contains("active")) {
            this.onSubscriptionActive();
        }
    }

    addWidgetEventListener() {
        if(this.oneTimeBtn && this.subscriptionBtn) {
            this.oneTimeBtn.addEventListener('click', () => {
                this.oneTimeBtn.classList.add("active");
                this.subscriptionBtn.classList.remove("active");
                
                if(this.subContent) {
                    this.subContent.classList.remove("open");
                }

                this.setSellingPlanInProductForms(null)
                
                if(!this.variantSelects) return;
                
                const subtotal = document.querySelector(".main-product__block-price .f-price__sale.subscription");
                if(subtotal) {
                    subtotal.style.display = "none";
                }

                const subtotalCompare = document.querySelector(".main-product__block-price .f-price__sale:not(.subscription)");
                if(subtotalCompare) {
                    subtotalCompare.style.display = "flex";
                }

                this.variantSelects.forEach((variant) => {
                    const originalPrice = variant.querySelector(".variant-picker-label-text:not(.subscription)");
                    const subPrice = variant.querySelector(".variant-picker-label-text.subscription");
                    
                    subPrice.classList.add("hidden");
                    originalPrice.classList.remove("hidden");
                });

                const atcSubtotal = document.querySelector(".sticky-atc-wrapper .product-price-wrapper .sticky-atc-price.subscription");
                if(atcSubtotal) {
                    atcSubtotal.classList.add("hidden");
                }
                
                const atcSubtotalCompare = document.querySelector(".sticky-atc-wrapper .product-price-wrapper .sticky-atc-price:not(.subscription)");
                if(atcSubtotalCompare) {
                    atcSubtotalCompare.classList.remove("hidden");
                }

                this.setStickyAtcVariant(true);
            });

            this.subscriptionBtn.addEventListener('click', (event) => {
                this.oneTimeBtn.classList.remove("active");
                this.subscriptionBtn.classList.add("active");

                this.onSubscriptionActive();
            });
        }
    }

    onSubscriptionActive() {
        if(this.subContent) {
            this.subContent.classList.add("open");
        }

        // Show subscription info
        const newSellingPlan = this.getSelectedVariant()?.dataset.sellingPlan;
        if(newSellingPlan) {
            this.setSellingPlanInProductForms(newSellingPlan);
        }
        
        this.setUspText();
        this.setSubtotal();
        this.setVariantPrices();
        this.setStickyAtcSubtotal();
        this.setStickyAtcVariant(false);
    }

    setUspText() {
        // Change price on total price
        const variant = this.getSelectedVariant();
        if(!variant) return;

        const planName = this.querySelector(".subscription-widget__content .selling-plan__name");
        if(planName) {
            planName.textContent = variant.dataset.planName;
        }
    }

    setSubtotal() {
        // Change price on total price
        const variant = this.getSelectedVariant();
        if(!variant) return;

        const dataset = variant.dataset;

        const subPrice = this.formatPrice(dataset.productSubPrice);

        const priceDiv = document.querySelector(".main-product__block-price .f-price__sale:not(.subscription)");
        let subPriceDiv = document.querySelector(".main-product__block-price .f-price__sale.subscription");

        if(priceDiv && !subPriceDiv) {
            const compareAtDiv = priceDiv.querySelector(".prod__compare_price");
            const compareAtPrice = compareAtDiv?.textContent || "";
            
            this.renderSubscriptionPrice(priceDiv, `<div class="f-price__sale subscription">
<span class="visually-hidden visually-hidden--inline">Sale price</span>
<span class="f-price-item f-price-item--sale text-xl md:text-2xl prod__price text-color-regular-price">${subPrice}</span>
<span class="visually-hidden visually-hidden--inline">Regular price</span>
<s class="f-price-item f-price-item--regular prod__compare_price line-through text-color-secondary flex items-center">${compareAtPrice}</s></div>`)
            subPriceDiv = document.querySelector(".main-product__block-price .f-price__sale.subscription");
        }
        
        if(priceDiv) {
            priceDiv.style.display = "none";
        }

        if(subPriceDiv) {
            subPriceDiv.querySelector(".main-product__block-price .f-price__sale.subscription .f-price-item--sale").textContent = subPrice;
            subPriceDiv.style.display = "flex";
        }
    }

    setVariantPrices() {
        if(!this.variantSelects) return;

        this.variantSelects.forEach((variant) => {
            const dataset = variant.dataset;
            if (dataset.productSubPrice != "" && dataset.productCount != "" && dataset.productCount != "0") {                        
                // Change price on variant selector
                const subPricePerItem = this.formatPrice(dataset.productSubPrice / dataset.productCount);

                const originalPricePerItem = this.formatPrice(dataset.currentPrice / dataset.productCount);

                const variantPriceDiv = variant.querySelector(".variant-picker-label-text:not(.subscription)");
                let variantSubPriceDiv = variant.querySelector(".variant-picker-label-text.subscription");

                if(variantPriceDiv && !variantSubPriceDiv) {
                    this.renderSubscriptionPrice(variantPriceDiv, `<div class="font-normal variant-picker-label-text subscription">${dataset.value.split("-")[0]} - <span class="text-color-regular-price">${subPricePerItem}</span> <s class="prod__compare_price">${originalPricePerItem}</s> ${ dataset.currentUnit }</div>`);
                    variantSubPriceDiv = variant.querySelector(".variant-picker-label-text.subscription");
                }

                if(variantPriceDiv) {
                    variantPriceDiv.classList.add("hidden");
                }

                if(variantSubPriceDiv) {
                    variantSubPriceDiv.classList.remove("hidden");
                }
            }
        });
    }

    setStickyAtcSubtotal() {
        // Change price on total price
        const variant = this.getSelectedVariant();
        if(!variant) return;

        const dataset = variant.dataset;

        const subPrice = this.formatPrice(dataset.productSubPrice);

        const priceDiv = document.querySelector(".sticky-atc-wrapper .product-price-wrapper .sticky-atc-price:not(.subscription)");
        let subPriceDiv = document.querySelector(".sticky-atc-wrapper .product-price-wrapper .sticky-atc-price.subscription");

        if(priceDiv && !subPriceDiv) {
            this.renderSubscriptionPrice(priceDiv, `<div class="sticky-atc-price subscription">${subPrice}`);
            subPriceDiv = document.querySelector(".sticky-atc-wrapper .product-price-wrapper .sticky-atc-price.subscription");
        }
        
        if(priceDiv) {
            priceDiv.classList.add("hidden");
        }

        if(subPriceDiv) {
            subPriceDiv.textContent = subPrice;
            subPriceDiv.classList.remove("hidden");
        }
    }

    setStickyAtcVariant(resetPrice) {
        if(!this.atcSelector) return;

        this.atcSelector.querySelectorAll("option").forEach((option) => {
            const dataset = option.dataset;

            if (dataset.productSubPrice != "" && dataset.productCount != "" && dataset.productCount != "0") {                        
                // Change price on variant selector
                const subPricePerItem = this.formatPrice(dataset.productSubPrice / dataset.productCount);
                const originalPricePerItem = this.formatPrice(dataset.currentPrice / dataset.productCount);

                option.textContent = `${dataset.value.split("-")[0]} - ${resetPrice ? originalPricePerItem : subPricePerItem} ${ dataset.currentUnit }`;
            }
        });
    }

    addVariantEventListener() {
        if(this.variantSelects) {
            this.variantSelects.forEach((variant) => {
                variant.addEventListener('click', (event) => {
                    this.onVariantChange(variant);
                });
            });
        }
    }

    addStickyAtcEventListener() {
        if(this.atcSelector) {
            this.atcSelector.addEventListener('change', (event) => {
                const variant = this.getSelectedVariant();
                if(!variant) return;

                const dataset = variant.dataset;

                const variantSelector = document.querySelector(".main-product__block-variant_picker variant-button");
                if(variantSelector) {
                    variantSelector.setAttribute("data-selected-value", dataset.value);
                }

                this.onVariantChange(variant);
            });
        }
    }

    getSelectedVariant() {
        return document.querySelector(`.main-product__block-variant_picker .variant-picker__option:has(input:checked)`)
    }

    onVariantChange(variant) {
        const dataset = variant.dataset;
        if (dataset.productSubPrice != "" && dataset.productCount != "" && dataset.productCount != "0") {                        
            // Change price on total price
            const subPrice = this.formatPrice(dataset.productSubPrice);

            const subtotal = document.querySelector(".main-product__block-price .f-price__sale.subscription .f-price-item--sale");
            if(subtotal) subtotal.textContent = subPrice;

            const atcSubtotal = document.querySelector(".sticky-atc-wrapper .product-price-wrapper .sticky-atc-price.subscription");
            if(atcSubtotal) atcSubtotal.textContent = subPrice;
        }

        // Set selling plan according to variant ONLY if the sub button is active
        if (this.subscriptionBtn.classList.contains("active")) {
            this.dataset.sellingPlan = dataset.sellingPlan;
            this.setSellingPlanInProductForms(dataset.sellingPlan);

            const planName = this.querySelector(".subscription-widget__content .selling-plan__name");
            if(planName) {
                planName.textContent = dataset.planName;
            }
        }
    }

    formatPrice(price) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(price / 100);
    }

    renderSubscriptionPrice(targetElement, innerHTML) {
        const newElement = document.createElement("div");
        newElement.innerHTML = innerHTML;
        targetElement.insertAdjacentHTML("afterend", newElement.innerHTML);
    }
    
    setSellingPlanInProductForms(sellingPlan) {
      const productInputs = document.querySelectorAll('input[name="product-id"]');
      if(!productInputs) return;
      
      const matchingInputs = Array.from(productInputs).filter(input => input.value === this.productId);
      matchingInputs.forEach(input => {
        let form = input.closest("form");
        const sellingPlanInputs = form.querySelector("input[name='selling_plan']");
        if (sellingPlanInputs) {
          sellingPlanInputs.value = sellingPlan;
          return;
        }
        // Create a new hidden input element for the selling plan
        const sellingPlanInput = document.createElement("input");
        sellingPlanInput.type = "hidden";
        sellingPlanInput.name = "selling_plan";
        sellingPlanInput.value = sellingPlan;
        form.appendChild(sellingPlanInput);
    });
}}
customElements.define("subscription-widget", SubscriptionWidget)